import React from 'react';
import PropTypes from 'prop-types';
import { ResponseMessage, UserMessage } from '../../message';
import modules from './item.module.scss'

const FeedItem = (props = {}) => {
    const { message, ResponseProps, ...addedProps } = props
    const { type, content, className, ...additionalMessage } = message

    let Component = null
    let itemProps = {
        ...addedProps,
        className: `${modules.item} ${className || ''}`.trim(),
        ...additionalMessage
    }
    let itemChildren = null

    if(type === 'response') {
        Object.assign(itemProps, ResponseProps ?? {})
        Component = ResponseMessage
        itemChildren = content
    } else if (type === 'input') {
        Component = UserMessage
        itemChildren = content
    }

    if(!Component) return null

    return <Component {...itemProps}>
        {itemChildren}
    </Component>
}

FeedItem.defaultProps = {
    className: '',
    handleInput: (value) => console.log(`Feed Item, Handle Input:`, value)
}

FeedItem.propTypes = {
    message: PropTypes.shape({
        type: PropTypes.oneOf(['response', 'input']),
        content: PropTypes.node,
        className: PropTypes.string
    })
}

export default FeedItem